import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { HideToolbarService } from 'src/app/shared/services/hideToolbar.service';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';

@Component({
  selector: 'app-busqueda',
  templateUrl: './busqueda.component.html',
  styleUrls: ['./busqueda.component.scss'],
})
export class BusquedaComponent extends AutoUnsubscribeComponent implements OnInit {
  public formRequest: FormGroup;
  public disableButtonValidate = false;
  public disableButtonBuscar = false;
  public token!: string;
  public cont = 0;
  public country = 'mx';
  public creditType = 9;
  truoraToken: string | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private getDataService: GetDataService,
    private requestFormService: RequestFormService,
    private router: Router,
    private dialog: MatDialog,
    private postDataService: PostDataService,
    private hideToolbarFormService: HideToolbarService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
    this.formRequest = this.formBuilder.group({
      requestNum: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]?[0-9]+$/)],
      ],
      mail: ['', [Validators.required, Validators.email]],
      securityCode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
    });
  }

  ngOnInit(): void {
    const activatedRouteSubscription$ = this.activatedRoute.paramMap.subscribe(params => {
      this.truoraToken = params.get('truoraToken');
      if (this.truoraToken) {
        this.validateUsingTruoraToken();
      }
    });
    this.subscriptions.push(activatedRouteSubscription$);
  }

  openRequestInformationDialog(error: HttpErrorResponse, truoraErr?: boolean) {
    let errorOldForm;
    let errorMessage =
      'Su solicitud no ha sido localizada y/o expiró, favor de verificar sus datos.';

    if (!truoraErr) {
      errorOldForm = 'The old form is permanently inaccessible'.match(
        error?.error.errors[0].message
      );
    }

    if (errorOldForm) {
      errorMessage = `Su solicitud no ha sido localizada y/o expiró, por favor cargue sus datos nuevamente`;
    }

    if (truoraErr) {
      errorMessage = 'Su solicitud no ha sido localizada y/o expiró, favor de verificar sus datos.';
    }

    const dropModal = this.dialog
      .open(RequestInformationComponent, {
        width: 'min(400px,90%)', maxWidth: 'none', data: {
          title: 'Información de busqueda',
          question: errorMessage,
        }
      });

    const closedSubscription$ = dropModal.afterClosed()
      .subscribe((resp) => {
        if (resp === undefined) {
          this.router.navigate([this.country + '/solicitud/'], {
            queryParams: { creditType: this.creditType },
          });
        }
      });
    this.subscriptions.push(closedSubscription$);
  }

  validateUsingTruoraToken() {
    if (!this.truoraToken) return;

    const postRequestTokenTruora$ = this.postDataService
      .postRequestTokenTruora(this.truoraToken)
      .subscribe({
        next: (resp) => {
          this.requestFormService.setUpdateForm(resp);
          this.setSessionStorageData();
          const creditTypeUpdate = this.getCreditTypeUpdate();

          this.router.navigate([this.country + '/solicitud/form/carga-documentos'], {
            queryParams: { creditType: creditTypeUpdate },
          });
          this.hideToolbarFormService.setHideToolbarForm(true);
          setTimeout(() => {
            this.disableButtonBuscar = true;
            this.disableButtonValidate = false;
          }, 60000);
        },
        error: (err) => {
          this.openRequestInformationDialog(err, true);
        },
      });
    this.subscriptions.push(postRequestTokenTruora$);
  }

  validateRequest() {
    const searchRequest = {
      email: this.formRequest.value.mail,
      requestNumber: this.formRequest.value.requestNum,
    };
    const postRequestToken$ = this.postDataService
      .postRequestToken(this.formRequest.value.mail, searchRequest)
      .subscribe({
        next: (value) => {
          this.openInformationSecurity();
          this.token = value.token;
          setTimeout(() => {
            this.disableButtonBuscar = true;
            this.disableButtonValidate = false;
          }, 60000);
        },
        error: (err) => {
          this.openRequestInformationDialog(err);
        },
      });
    this.subscriptions.push(postRequestToken$);
  }

  openInformationSecurity() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Información',
      question: `Le enviamos un código a su email para que pueda acceder.`,
    };
    dialogConfig.disableClose = true;
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.disableButtonValidate = true;
      });
  }

  disableButtonSearch() {
    return !(
      this.formRequest.controls['requestNum'].valid &&
      this.formRequest.controls['mail'].valid
    );
  }

  validateSegurityCode(withTruora: boolean) {
    sessionStorage.removeItem('referralCode');
    const getUpdateDataTokenCode$ = this.getDataService
      .getUpdateDataTokenCode(
        this.formRequest.value.mail,
        this.token,
        this.formRequest.value.securityCode
      )
      .subscribe({
        next: (resp) => {
          const dataForm = {
            email: this.formRequest.value.mail,
            requestNumber: this.formRequest.value.requestNum,
          };
          this.requestFormService.setDataForm(dataForm);
          this.requestFormService.setUpdateForm(resp);

          this.setSessionStorageData();

          const creditTypeUpdate = this.getCreditTypeUpdate();

          if (this.requestFormService.getUpdateForm().flowVersion === 3) {
            this.router.navigate([this.country + '/solicitud/form/carga-documentos'], {
              queryParams: { creditType: creditTypeUpdate },
            });
            // sessionStorage.setItem('hidePageConfirmationPlatform', 'true')
            this.hideToolbarFormService.setHideToolbarForm(true);
          } else {
            this.router.navigate([this.country + '/solicitud/'], {
              queryParams: { creditType: creditTypeUpdate },
            });
          }

        },
        error: (err) => {
          if (
            err.status === 400 &&
            err.error.errors[0].message === 'Definitive Reject Status'
          ) {
            this.openErrorStatusRechazadaDefinitiva();
          } else {
            if (this.cont < 4) {
              this.cont = this.cont + 1;
              this.openValidateToken();
              if (this.cont === 3) {
                this.disableButtonValidate = false;
                setTimeout(() => {
                  window.location.href = '/busqueda';
                }, 1000);
              }
            }
          }
        },
      });
    this.subscriptions.push(getUpdateDataTokenCode$);
  }

  getCreditTypeUpdate(): string {
    return this.requestFormService.getUpdateForm().creditType.code === 'DAE' ? '9' : '1';
  }

  setSessionStorageData(): void {
    sessionStorage.setItem('requestNumber', this.requestFormService.getUpdateForm()?.requestNumber);
    sessionStorage.setItem('creditType', this.requestFormService.getUpdateForm()?.creditType.code.toString());
    sessionStorage.setItem('stepNumber',
      this.requestFormService.getUpdateForm()?.formStep
        ? this.requestFormService.getUpdateForm()?.formStep.toString()
        : this.requestFormService
          .getUpdateForm()
          ?.lastSectionCompleted.toString()
    );
  }

  openValidateToken() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Información',
      question:
        `El código de acceso ingresado es incorrecto y/o expiró. \nVerifique el valor ingresado. \nLe quedan ${-this.cont + 3
        }` + (this.cont === 2 ? ` intento.` : ` intentos.`),
    };
    dialogConfig.disableClose = true;
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  openErrorStatusRechazadaDefinitiva() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Información sobre su solicitud',
      question: `Su solicitud ha sido rechazada por el equipo de análisis.`,
    };
    dialogConfig.disableClose = true;
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        window.location.href = '/busqueda';
      });
  }
}
